var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 453,
    height: 345,
    viewBox: "0 0 453 345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 453,
    height: 345
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 453,
    height: 345,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50.541 -101.419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.522,425.1C86.144,425.1,72,411.232,72,394.192v-251.7C72,125.454,81.641,116,99.019,116h355.75c17.378,0,31.522,13.87,31.522,30.91V394.192c0,17.04-14.144,30.91-31.522,30.91Z",
    transform: "translate(0 0)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.336,
    cy: 9.336,
    r: 9.336,
    transform: "translate(90.452 134.671)",
    fill: "#cc584c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.336,
    cy: 9.336,
    r: 9.336,
    transform: "translate(118.459 134.671)",
    fill: "#ffd464"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.336,
    cy: 9.336,
    r: 9.336,
    transform: "translate(143.72 134.671)",
    fill: "#198058"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.671 134.671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.88,146a4.682,4.682,0,0,1-4.668,4.668H168.48A4.682,4.682,0,0,1,163.812,146v-9.336A4.682,4.682,0,0,1,168.48,132H439.212a4.682,4.682,0,0,1,4.668,4.668Z",
    transform: "translate(-90.489 -132)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.949,389.735a8.858,8.858,0,0,1-8.975,8.682h-359A8.858,8.858,0,0,1,88,389.735V172.682A8.858,8.858,0,0,1,96.975,164h359a8.858,8.858,0,0,1,8.975,8.682Z",
    transform: "translate(-88 -126.658)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.342 173.041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.349,385.383a9.363,9.363,0,0,1-9.336,9.336H113.336A9.363,9.363,0,0,1,104,385.383V189.336A9.363,9.363,0,0,1,113.336,180h46.678a9.363,9.363,0,0,1,9.336,9.336Z",
    transform: "translate(-104 -180)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.4,180a9.363,9.363,0,0,1,9.336,9.336v46.678a9.357,9.357,0,0,1-9.336,9.336H185.336A9.357,9.357,0,0,1,176,236.013V189.336A9.363,9.363,0,0,1,185.336,180Z",
    transform: "translate(-107.125 -180)",
    fill: "#fbb040"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(178.321 257.629)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 270.608,
    height: 9.994,
    transform: "translate(0 0)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 270.608,
    height: 9.225,
    transform: "translate(0 14.607)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 270.608,
    height: 9.225,
    transform: "translate(0 28.445)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.733,
    height: 60.733,
    transform: "translate(0 42.282)",
    fill: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 60.733,
    height: 60.733,
    transform: "translate(255.561 299.035)",
    fill: "#0dcca5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(318.237 299.035)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.733,
    height: 60.733,
    transform: "translate(0 0)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.733,
    height: 60.733,
    transform: "translate(69.958 0)",
    fill: "#b3b3b3"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.b57f5103f2e3d65115622d0614684c75.svg";
export { ForwardRef as ReactComponent };